import { Component, OnInit } from "@angular/core";
import { ToastrService } from "ngx-toastr";
import { DashboardService } from "src/app/services/dashboard.service";
import { Meses } from "src/app/utils/meses";
import { SCAMP_API } from "src/environments/environment";
import { DescricaoValorViewModel } from "../domain/viewmodels.models";

@Component({
  selector: "app-quantitativo-servicos",
  templateUrl: "./quantitativo-servicos.component.html",
  styleUrls: ["./quantitativo-servicos.component.scss"],
})
export class QuantitativoServicosComponent implements OnInit {
  constructor(
    private dashboardService: DashboardService,
    private toastr: ToastrService
  ) {}

  public quantitativoServicos: any[] = [];

  currentDate = new Date();
  isProcessing: boolean = false;
  optionChartColumn: any = null;

  totalAbertas: number = 0;
  totalAtendidas: number = 0;
  totalEmAndamento: number = 0;
  totalNaoAtendidas: number = 0;

  meses = Meses.meses;
  selectionMonth: number = 0;
  selectionYear: number | null = null;
  tipoResumo: string = "status";
  anos = [
    new Date().getFullYear() - 4,
    new Date().getFullYear() - 3,
    new Date().getFullYear() - 2,
    new Date().getFullYear() - 1,
    new Date().getFullYear(),
  ];

  resumos: DescricaoValorViewModel[] = [];
  totalResumo: number = 0;
  excelFileName: string = "";
  hrefExcelFile: string = "";
  noZero: boolean = false;
  tipoValoresGrafico = "percentuais";

  ngOnInit() {
    this.selectionYear = this.currentDate.getFullYear();
    this.submit();
  }

  optionMonth(month) {
    this.selectionMonth = month;
    this.showGraph();
  }

  optionYear(ano: number) {
    if (ano != this.selectionYear) {
      this.selectionYear = ano;
      this.submit();
    }
  }

  changeNoZero() {
    this.noZero = !this.noZero;
  }

  changeTipoValoresGrafico(tipo: string) {
    this.tipoValoresGrafico = tipo;
    this.showGraph();
  }

  retreatYear() {
    if (this.anos[0] < new Date().getFullYear() - 10) {
      return;
    }

    //this.selectionMonth = 0
    this.anos[0] = this.anos[0] - 5;
    this.anos[1] = this.anos[1] - 5;
    this.anos[2] = this.anos[2] - 5;
    this.anos[3] = this.anos[3] - 5;
    this.anos[4] = this.anos[4] - 5;
  }

  forwardYear() {
    if (this.anos[4] == new Date().getFullYear()) {
      return;
    }

    this.selectionMonth = 0;
    this.anos[0] = this.anos[0] + 5;
    this.anos[1] = this.anos[1] + 5;
    this.anos[2] = this.anos[2] + 5;
    this.anos[3] = this.anos[3] + 5;
    this.anos[4] = this.anos[4] + 5;
  }

  changeTipoResumo(tipo) {
    this.tipoResumo = tipo;
    this.showGraph();
  }

  submit() {
    this.isProcessing = true;
    this.resumos = [];
    this.selectionMonth = 0;
    this.excelFileName = "";
    this.hrefExcelFile = "";

    this.dashboardService.getQuantitativoServicos(this.selectionYear).subscribe(
      (response) => {
        this.quantitativoServicos = response;

        this.showGraph();
      },
      (exception: any) => {
        this.showErrorExecption(exception);
        this.isProcessing = false;
      },
      () => (this.isProcessing = false)
    );
  }

  getServicosByStatus = (status) => {
    return this.quantitativoServicos.filter(
      (x) => x.status.toLowerCase() === status.toLowerCase()
    );
  };

  getTotalServicos = (servicos) => {
    return servicos
      .map((t) =>
        this.selectionMonth == 0
          ? t.acumulado
          : t[
              String(
                this.meses[this.selectionMonth - 1].nome_abrev
              ).toLowerCase()
            ]
      )
      .reduce((acumulador, value) => acumulador + value, 0);
  };

  getSubTotalByArea = (descricao, servicos) => {
    return servicos
      .filter((t) => t.areaTecnica === descricao)
      .map((t) =>
        this.selectionMonth == 0
          ? t.acumulado
          : t[
              String(
                this.meses[this.selectionMonth - 1].nome_abrev
              ).toLowerCase()
            ]
      )
      .reduce((acumulador, value) => acumulador + value, 0);
  };

  showGraph() {
    this.resumos = [];
    this.totalResumo = 0;
    this.optionChartColumn = undefined;

    const servicosAtendimentos = this.getServicosByStatus("atendidas");
    const servicosEmAndamento = this.getServicosByStatus("em andamento");
    const servicosNaoAtendidos = this.getServicosByStatus("não atendidas");
    const servicosAbertos = this.getServicosByStatus("abertas");
    

    if (this.tipoResumo === "status") {
      const totalAtendidas = this.getTotalServicos(servicosAtendimentos);
      const totalEmAndamento = this.getTotalServicos(servicosEmAndamento);
      const totalNaoAtendidas = this.getTotalServicos(servicosNaoAtendidos);
      const totalAbertas = (totalAtendidas + totalNaoAtendidas + totalEmAndamento);

      let serieData = [];

      this.resumos.push({
        descricao: "Atendidas",
        descricaoAbrev: "Atend",
        valor: totalAtendidas,
      });
      this.resumos.push({
        descricao: "Não atendidas",
        descricaoAbrev: "Não atend",
        valor: totalNaoAtendidas,
      });
      this.resumos.push({
        descricao: "Em andamento",
        descricaoAbrev: "Em andam",
        valor: totalEmAndamento,
      });
     



      this.totalResumo = totalAbertas;

      if (this.totalResumo > 0) {
        if (this.tipoValoresGrafico == "numericos") {
          serieData = this.resumos.map((t) => t.valor);
        } else {
          serieData = this.resumos.map((t) =>
            ((t.valor / this.totalResumo) * 100).toFixed(2)
          );
        }

        let serie = { type: "column", data: serieData };
        let yaxis = { show: false };

        this.displayGraphInWindow(
          [].concat(serie),
          yaxis,
          this.tipoValoresGrafico
        );
      }
    }

    // -------------------------------------------------------------------

    if (this.tipoResumo === "area") {
      let DescricoesDistincts = [
        ...new Set(this.quantitativoServicos.map((t) => t.areaTecnica)),
      ];

      let serieData = [];
      let serieData2 = [];
      let serieData3 = [];
      let totalAtendimentos = 0;
      let totalEmAndamento = 0;
      let totalNaoAtendidos = 0;

      DescricoesDistincts.forEach((descricao) => {
        const subTotalAtendidas = this.getSubTotalByArea(
          descricao,
          servicosAtendimentos
        );
        const subTotalEmAndamento = this.getSubTotalByArea(
          descricao,
          servicosEmAndamento
        );
        const subTotalNaoAtendidas = this.getSubTotalByArea(
          descricao,
          servicosNaoAtendidos
        );

        this.resumos.push({
          descricao: descricao,
          descricaoAbrev: descricao.substring(0, 3),
          valor: subTotalAtendidas,
          valor3: subTotalNaoAtendidas,
          valor2: subTotalEmAndamento
        });

        totalAtendimentos += subTotalAtendidas;
        totalEmAndamento += subTotalEmAndamento;
        totalNaoAtendidos += subTotalNaoAtendidas;
        this.totalResumo += subTotalAtendidas + subTotalEmAndamento + subTotalNaoAtendidas;
      });

      if (this.totalResumo > 0) {
        if (this.tipoValoresGrafico == "numericos") {
          serieData = this.resumos.map((t) => t.valor);
          serieData2 = this.resumos.map((t) => t.valor2);
          serieData3 = this.resumos.map((t) => t.valor3);
        } else {
          serieData = this.resumos.map((t) =>
            ((t.valor / totalAtendimentos) * 100).toFixed(1)
          );
          serieData2 = this.resumos.map((t) =>
            ((t.valor2 / totalEmAndamento) * 100).toFixed(1)
          );
          serieData3 = this.resumos.map((t) =>
          ((t.valor3 / totalNaoAtendidos) * 100).toFixed(1)
        );
        }

        let serie = {
          name: "% em relação ao total atendimentos",
          type: "column",
          data: serieData,
        };
       
        let serie3 = {
          name: "% em relação ao total não atendidos",
          type: "column",
          data: serieData3,
        };
        let serie2 = {
          name: "% em relação ao total em andamento",
          type: "column",
          data: serieData2,
        };

        let series = [];
        series.push(serie);
        series.push(serie3);
        series.push(serie2);
        let yaxis = { show: false };

        this.displayGraphInWindow(series, yaxis, this.tipoValoresGrafico);
      }
    }
  }

  displayGraphInWindow(series, yaxis, tipoGrafico) {
    this.optionChartColumn = {
      chart: { height: "190", type: "bar" },
      series: series,
      stroke: { show: true, width: [2] },
      xaxis: {
        categories: [...this.resumos.map((t) => t.descricaoAbrev)],
        //labels: { show: true, rotate: -90, rotateAlways: true },
      },
      yaxis: [yaxis],
      plotOptions: {
        bar: {
          horizontal: false,
          endingShape: "rounded",
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (value, { seriesIndex, dataPointIndex, w }) {
          return `${value.toLocaleString()}${
            tipoGrafico == "percentuais" ? "% " : ""
          }`;
        },
        style: {
          fontWeight: 700,
          colors: ["#000"],
          fontSize: "10px",
        },
      },
      //title: { text: 'Gráfico resumo', align: 'center', margin: 10, style: {fontSize: '12px', color: '#808080'} }
    };
  }

  exportarToExcel() {
    this.isProcessing = true;
    this.excelFileName = "";
    this.hrefExcelFile = "";

    this.dashboardService
      .exportarQuantitativoServicosToExcel(this.selectionYear)
      .subscribe((response) => {
        if (response.success === true) {
          if (response.nenhumResultado === false) {
            this.excelFileName = response.fileName;
            this.hrefExcelFile = `${SCAMP_API.pathDownloadExcel}/${response.fileName}`;
          } else {
            this.toastr.warning(response.msgErro);
          }

          this.isProcessing = false;
        } else {
          this.toastr.error(response.msgException);
          this.isProcessing = false;
        }
      });
  }

  /* METHODS PRIVATES */

  private showErrorExecption(exception: any) {
    let msg = exception.message;
    if (Number(exception.status) === 0) {
      msg = "A aplicação não conseguiu se conectar ao Servidor";
    }
    if (Number(exception.status) === 500) {
      msg = "O Servidor gerou um erro de processamento";
    }
    this.toastr.error(
      `<b>Erro no Servidor</b><br /><br />status: <b>${exception.status}</b><br /><br />${msg}`
    );
  }
}
